export default "__VITE_ASSET__DVN3VVYs__"